<template>
  <div class="form-group">
    <div>
      <label class="label-option">
        {{ hintLabel }}
        <span
          class="title-table-presentation-tooltip result-layout-tooltip tooltip-on-hover"
        >
          <span
            v-tooltip="hintTooltip"
            class="tooltip-btn"
          />

          <i class="fas fa-question-circle" />
        </span>
      </label>
      <div>
        <draggable
          v-if="isDraggableHintsVisible"
          v-model="slideActive.hints"
          class="list-group"
          tag="ul"
          v-bind="dragOptions"
          :disabled="isSortingHints"
          draggable=".draggable-item"
          @start="drag = true"
          @end="drag = false"
          @change="handleSortHints"
        >
          <li
            v-for="(item, index) in slideActive.hints"
            :key="'hint_' + item.order +' '+ keyInput + index"
            :class="{ 'd-none': isHideOptions(index), 'draggable-item': item.id }"
          >
            <div class="mb-2 input-group input-option">
              <div
                class="input-group-prepend handle-drag"
                :class="{ 'disabled': isSortingHints || !item.id }"
              >
                <div class="input-group-text horizontal layout center center-justified">
                  <i class="fas fa-arrows-alt-v" />
                </div>
              </div>
              <div class="input-content-wrapper">
                <InputText
                  :id="item.id"
                  :key="'hint_' + index + item.index + keyInput"
                  :val="item.title"
                  :index="index"
                  :place-holder="hintPlaceholder + ' ' + (index + 1)"
                  :type="'input-option'"
                  :id-name="'hintIndex'"
                  :inputId="`slide-option-${item.id}`"
                  @interface="handleUpdateHintTitle"
                  :limit="50"
                  isHintsInput
                  @addHint="handleAddHint"
                />

                <!-- <SlideHintsImageButton
                  :hint="item"
                  :index="index"
                /> -->
              </div>

              <div class="ml-2 input-group-prepend pointer">
                <div
                  class="input-group-text horizontal layout center center-justified"
                  @click="$emit('deleteHint', item, index)"
                >
                  <i class="far fa-trash-alt" />
                </div>
              </div>
            </div>
          </li>
        </draggable>

        <aha-antd-button
          v-aha-emit-action
          name="add-hint-button"
          icon-name="add"
          variant="secondary"
          v-if="isAddHintButtonVisible"
          class="w-full mb-1"
          @click="$emit('addHint')"
        >
          <span>{{ $i18nPresenter.t("Add") }}</span>
        </aha-antd-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import InputText from '@/components/presentations/InputText.vue'
// import SlideHintsImageButton from '@/components-v2/presentation-editor/side-right/hints/SlideHintsImageButton.vue'

export default {
  components: {
    draggable,
    InputText,
    // SlideHintsImageButton,
  },
  props: {
    isSortingHints: {
      type: Boolean,
      default: false,
    },
    openTooltipImage: {
      type: String,
      default: null,
    },
    hintLabel: {
      type: String,
      default: 'Options',
    },
    hintTooltip: {
      type: String,
      default: '',
    },
    hintPlaceholder: {
      type: String,
      default: 'Option',
    },
    keyInput: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      drag: false,
      countCorrectOption: 0,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    ...mapGetters(['getSlideOptionsActive']),
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        delay: 0,
        ghostClass: 'ghost',
        handle: '.handle-drag',
      }
    },
    isDraggableHintsVisible() {
      return this.slideActive.hints && this.slideActive.hints.length
    },
    isAddHintButtonVisible() {
      return this.slideActive.hints && this.slideActive.hints.length &&
        this.slideActive.hints.length < 3
    },
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),
    handleSortHints(event) {
      this.$emit('sortHints', event)
    },
    isHideOptions(index) {
      const { type } = this.slideActive
      return index > 29 ||
        (index > 7 && (type === 'pickAnswer' || type === 'scale')) ||
        (index > 14 && (type === 'bulletPoints'))
    },
    handleUpdateHintTitle(value) {
      this.$emit('updateHintTitle', value)
    },
    handleAddHint(keyMode) {
      if (!this.isAddHintButtonVisible) return
      this.$emit('addHint', keyMode)
    },
  },
}
</script>

<style lang="scss" scoped>
$success: #33C173;
$secondary: #B4BCCF;
$white: #fff;
$gray: #ddd;

.input-content-wrapper {
  display: flex;
  flex-grow: 1;

  @media (min-width: 992px) {
    &:hover {
      .checkmark {
        visibility: visible;
      }
    }
  }
}
.input-option {
  & ::v-deep .input-style {
    width: min-content;
    z-index: 1;
  }
}
ul {
  li {
    list-style: none;
  }
}
</style>
